import React, { useCallback, useEffect, useState } from "react";
import {
  AdvancedMarker,
  InfoWindow,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";
import VehiclePopup from "../common/VehiclePopUp";
import { routeService } from "../../../const";
import { useDispatch, useSelector } from "react-redux";
import { missionControlActions } from "../../../store/mission-control/mission-control-slice";
import RotatableMarker from "./RotatableMarker";
import StationaryMarker from "./StationaryMarker";

const MovingMarkerWithInfoWindow = ({
  vehicle,
  setMarkerRef,
  jobVehicleInfoToggle,
  handleAdvancedDirectionResponse,
  advancedDirectionVehicle,
}) => {
  const [markerRef, marker] = useAdvancedMarkerRef();
  const [infoWindowShown, setInfoWindowShown] = useState(false);
  const dispatch = useDispatch();

  const showAdvancedDirection = useSelector(
    (state) =>
      state.missionControl.advancedDirections[advancedDirectionVehicle],
  );

  const handleMarkerClick = useCallback(() => {
    setInfoWindowShown((isShown) => !isShown);
  }, []);

  const handleClose = useCallback(() => {
    setInfoWindowShown(false);
  }, []);

  useEffect(() => {
    if (marker) {
      setMarkerRef(marker, vehicle.terminalId);
    }
  }, [setMarkerRef, marker, vehicle.terminalId]);

  useEffect(() => {
    dispatch(
      missionControlActions.setSpeed({
        terminalId: vehicle.terminalId,
        speed: vehicle.speed,
      }),
    );
  }, [dispatch, vehicle.speed, vehicle.terminalId]);

  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        position={{
          lat: vehicle.latitude,
          lng: vehicle.longitude,
        }}
        onClick={handleMarkerClick}
        key={vehicle.vehicleNo}
      >
        {vehicle.speed > 0 ? (
          <RotatableMarker
            color={vehicle.speed > 40 ? "red" : "green"}
            rotation={vehicle.direction}
            vehNo={vehicle.vehicleNo}
            advDirSelected={
              showAdvancedDirection &&
              advancedDirectionVehicle === vehicle.terminalId
            }
          />
        ) : (
          <StationaryMarker
            speed={vehicle.speed}
            terminalId={vehicle.terminalId}
            vehNo={vehicle.vehicleNo}
            advDirSelected={
              showAdvancedDirection &&
              advancedDirectionVehicle === vehicle.terminalId
            }
          />
        )}
      </AdvancedMarker>
      {infoWindowShown && (
        <InfoWindow anchor={marker} onCloseClick={handleClose}>
          <VehiclePopup
            socketData={vehicle}
            jobVehicleInfoToggle={jobVehicleInfoToggle}
            ds={routeService.GOOGLE}
            handleAdvancedDirectionResponse={handleAdvancedDirectionResponse}
          />
        </InfoWindow>
      )}
    </>
  );
};

export default MovingMarkerWithInfoWindow;
